import React from 'react'
import S from './styled'

const MainLayout = ({ children }) => (
  <S.MainLayout>
    {children}
  </S.MainLayout>
)

export default MainLayout
